import React, { Component, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Table,
  Spinner,
  Button,
} from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';

import { getBeritaPortal } from '../../actions/BeritaAction';
import { DELETE_BERITA, GET_TOKEN } from 'utils';

import swal from 'sweetalert';
import axios from 'axios';
import { logOutUser } from 'actions/AuthAction';
import jwt_decode from 'jwt-decode';

export default function ListBerita(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    getBeritaPortalError,
    getBeritaPortalLoading,
    getBeritaPortalResult,
  } = useSelector((state) => state.BeritaReducer);

  // auth

  const [token, setToken] = useState('');
  const [nama, setNama] = useState('');
  const [username, setUsername] = useState('');
  const [acses, setAkses] = useState('');
  const [expire, setExpire] = useState('');
  const [idAdmin, setIdAdmin] = useState('1');
  const [accessToken, setAccessToken] = useState('');

  const refreshToken = async () => {
    try {
      const response = await axios.get(GET_TOKEN + '/token');
      setToken(response.data);
      const decoded = jwt_decode(response.data.accessToken);
      setAccessToken(response.data.accessToken);
      setNama(decoded.nama);
      setUsername(decoded.username);
      setAkses(decoded.akses.split(','));
      setExpire(decoded.exp);
      setIdAdmin(decoded.idAdmin);
    } catch (error) {
      if (error.response) {
        dispatch(logOutUser(history));
        history.push('/');
      }
    }
  };

  const axiosJWT = axios.create();

  axiosJWT.interceptors.request.use(
    async (config) => {
      const currentDate = new Date();
      if (expire * 1000 < currentDate.getTime()) {
        const response = await axios.get(GET_TOKEN + '/token');
        config.headers.Authorization = `Bearer ${response.data.accessToken}`;
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        setNama(decoded.nama);
        setUsername(decoded.username);
        setAkses(decoded.akses);
        setIdAdmin(decoded.idAdmin);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  //auth

  useEffect(() => {
    dispatch(getBeritaPortal());
    refreshToken();
  }, []);

  // componentDidUpdate(prevProps) {
  //   const { deleteJerseyResult } = this.props;

  //   if (
  //     deleteJerseyResult &&
  //     prevProps.deleteJerseyResult !== deleteJerseyResult
  //   ) {
  //     swal('Sukses!', deleteJerseyResult, 'success');
  //     this.props.dispatch(getListJersey());
  //   }
  // }

  const removeData = async (id) => {
    try {
      await axios.delete(DELETE_BERITA + `${id}`, {
        credentials: 'include',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      swal('Sukses!', 'Berita berhasil dihapus', 'success');
      history.push('/admin');
      history.push('/admin/berita');
    } catch (error) {
      swal('Failed!', 'Forbiden', 'error');
    }
  };

  return (
    <div className='content'>
      <Row>
        <Col md='12'>
          <Card>
            <CardHeader>
              <CardTitle tag='h4'>List Berita</CardTitle>
              <Link
                to={'/admin/berita/tambah/' + idAdmin}
                className='btn btn-primary float-right'
              >
                Tambah Berita
              </Link>
            </CardHeader>
            <CardBody style={{ overflowX: 'auto' }}>
              <Table>
                <thead className='text-primary'>
                  <tr>
                    <th>Id</th>
                    <th>Foto</th>
                    <th>Judul</th>
                    <th>Kategori</th>
                    <th>Penulis</th>
                    <th>Status</th>
                    <th>Sumber</th>
                    <th>Tanggal</th>
                    <th>Aksi</th>
                  </tr>
                </thead>

                <tbody>
                  {getBeritaPortalResult ? (
                    Object.keys(getBeritaPortalResult).map((key) => (
                      <tr key={key}>
                        <td>{getBeritaPortalResult[key].id}</td>
                        <td>
                          <img
                            src={
                              getBeritaPortalResult[key].gambar.split(',')[0]
                            }
                            width='100'
                            alt={getBeritaPortalResult[key].kategori}
                          />
                        </td>
                        <td>{getBeritaPortalResult[key].judul}</td>
                        <td>{getBeritaPortalResult[key].kategori}</td>
                        <td>{getBeritaPortalResult[key].penulis} </td>
                        <td>{getBeritaPortalResult[key].status} </td>
                        <td>{getBeritaPortalResult[key].sumber} </td>
                        <td>{getBeritaPortalResult[key].tanggal} </td>
                        <td>
                          <Link
                            className='btn btn-warning'
                            to={
                              '/admin/berita/edit/' +
                              getBeritaPortalResult[key].id +
                              ',' +
                              idAdmin
                            }
                          >
                            <i className='nc-icon nc-ruler-pencil'></i> Edit
                          </Link>
                        </td>
                        <td>
                          <Button
                            color='danger'
                            className='ml-2'
                            onClick={() =>
                              removeData(getBeritaPortalResult[key].id)
                            }
                          >
                            <i className='nc-icon nc-basket'></i> Hapus
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : getBeritaPortalLoading ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        <Spinner color='primary' />
                      </td>
                    </tr>
                  ) : getBeritaPortalError ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        {getBeritaPortalError}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan='6' align='center'>
                        Data Kosong
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
